import React from 'react'
import SbEditable from "storyblok-react"
import FluidImage from 'src/utils/FluidImage'
import Heading from 'src/components/Heading'
import BrandLogo from 'src/utils/BrandLogo'
import RichText from 'src/utils/RichText'

const SlimlineHero = ({ blok }) => {
    return (
        <SbEditable content={blok} key={blok._uid}>
            <div className={`relative bg-${blok.colour === "" ? "" : blok.colour}`}>
                <div className="absolute inset-0">
                    {blok.background_image?.filename && <FluidImage className="w-full h-full object-cover" image={blok.background_image} alt={blok.background_image.alt} />}
                    <div className={`absolute inset-0 bg-${blok.colour === "" ? "" : blok.colour} bg-blend-screen opacity-80`} aria-hidden="true"></div>
                </div>
                <div className={`relative max-w-7xl mx-auto ${blok.colour === "" ? "py-24 sm:py-44" : "py-16 sm:py-24"} px-4 sm:px-6 lg:px-8 text-center`}>
                    <div className={`mx-auto w-inherit text-center ${["teal", "mustard", "darkorange", "darkblue"].includes(blok.colour) ? "inline-block" : "hidden"}`}>
                      <BrandLogo colour={blok.colour} />
                    </div>
                    <Heading size="h1" className={`lg:text-[100px] text-white mb-0 ${["", "darkgrey"].includes(blok.colour) ? "redBold" : ""}`}><RichText>{blok.title}</RichText></Heading>
                    {/* Initially created to use for archives */}
                    {blok.description && 
                        <div className="text-white font-body">
                            {blok.description}
                        </div>
                    }
                </div>
            </div>
        </SbEditable>
    )
}

export default SlimlineHero